import React, {Component} from "react";
import {Container} from "@mui/material";
import {Col, Row} from "react-bootstrap";
import ColumnChart from "./ColumnChart";
import Util from "../../Util/Util";
import Config from "../../Config";

export default class ChartView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            chartData: []
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }

    componentDidMount() {
        Util.loadData(Config.LOAD_CHARTS_API, res => {
            this.setState({chartData: res.data, loading: false});
        })
    }

    render() {
        let {loading, chartData} = this.state;
        let rows = [];
        Object.keys(chartData).forEach(function (key, index) {
            let title = "";
            switch (key) {
                case "ageGaps":
                    title = "Pacientes por edades";
                    break;
                case "consultGaps":
                    title = "Consultas por edades";
                    break;
                default:
                    title = "No data";
            }
            rows.push(
                <Row className="mt-3">
                    <Col sx={{padding: "0"}}>
                        <ColumnChart title={title} chartData={chartData[key]}/>
                    </Col>
                </Row>
            );
        });

        return (
            <Container className={"mw-100"}>
                {loading ? Util.renderLoading() : rows}
            </Container>
        )
    }
}